<section class="app-component">
    <router-outlet></router-outlet>
</section>
<app-loader></app-loader>
<app-loader loaderId="report-loader" text="Don't Go back or refresh page"></app-loader>